import { Component } from '@theme/component';

class HallowayStickyPurchase extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.root = this.closest('.hw-belgrave');
    this.mobile = matchMedia('(max-width: 899px)');
    this.dataset.hwManaged = 'true';
    this.hidden = false;
    for (const type of ['scroll', 'resize', 'focusin', 'focusout', 'toggle', 'close']) {
      document.addEventListener(type, this.schedule, { capture: true, passive: true, signal });
    }
    window.addEventListener('resize', this.schedule, { passive: true, signal });
    visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
    visualViewport?.addEventListener('scroll', this.schedule, { passive: true, signal });
    this.mobile.addEventListener('change', this.schedule, { signal });
    this.resizeObserver = new ResizeObserver(this.schedule);
    if (this.root) this.resizeObserver.observe(this.root.querySelector('.hw-purchase'));
    this.observer = new MutationObserver(this.schedule);
    this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['scroll-lock'] });
    this.observer.observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
    this.refresh();
  }

  updatedCallback() {
    super.updatedCallback();
    this.schedule();
  }

  schedule = () => {
    if (!this.frame) this.frame = requestAnimationFrame(this.refresh);
  };

  refresh = () => {
    this.frame = 0;
    if (!this.isConnected) return;
    const primary = this.root?.querySelector('.buy-buttons-block button[type="submit"]');
    const box = primary?.getBoundingClientRect();
    const viewportTop = visualViewport?.offsetTop || 0;
    const viewportBottom = viewportTop + (visualViewport?.height || innerHeight);
    const header = document.querySelector('#header-component')?.getBoundingClientRect();
    const top = Math.max(viewportTop, header && header.top <= viewportTop ? header.bottom : viewportTop);
    const primaryVisible = box && box.top >= top && box.bottom <= viewportBottom - 8;
    const overlay = document.documentElement.hasAttribute('scroll-lock') || document.querySelector('dialog[open], #Details-menu-drawer-container[open]');
    const editing = this.mobile.matches && document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea, select, [contenteditable="true"]');
    const visible = !!box && !overlay && !editing && (this.mobile.matches ? !primaryVisible : box.bottom <= top);
    if (this.dataset.hwVisible !== String(visible)) {
      this.dataset.hwVisible = String(visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
    }
  };

  disconnectedCallback() {
    super.disconnectedCallback();
    this.controller?.abort();
    this.resizeObserver?.disconnect();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
  }
}

if (!customElements.get('hw-sticky-purchase')) customElements.define('hw-sticky-purchase', HallowayStickyPurchase);
